import { IProductTour } from 'src/models/productTour';
import { CreateObjectStep } from './CreateObject';
import { CreateGroupObjectStep } from './CreateGroupObject';
import { ComparisonStep } from './ComparisonTour';
import { CustomDashboardStep } from './CustomDashboardTour';
import { OverviewStep } from './OverviewTour';
import { SocmedOverviewStep } from './SocmedOverviewTour';

export const productTour: IProductTour[] = [
  OverviewStep,
  SocmedOverviewStep,
  CreateObjectStep,
  CreateGroupObjectStep,
  CustomDashboardStep,
  ComparisonStep
];
